export let ResetContrato = {
	cod_app: '',
	dados_empresa: {
		cnpj: '',
		razao_social: '',
		email: '',
		contrato: '',
		total_funcionarios: 0,
	},
	mapeamento: [],
	atividade_principal: '',
	atividade_principal_cnpj: '',
	atividades: [],

	dados_tecnicos: {
		cipa_grupo: '',
		cipa_membros: '',
		atividade_economica: '',
		grau_risco: '',
		enquadramento: '',
		efetivo: '',
		suplente: '',
	},
};
export let ResetMapeamento = {
	id: null,
	ativo: true,
	imagens: [],
	setor: '',
	descricao: '',
	equipamentos: [],
	funcoes: [],
};
export let ResetEquipamentos = {
	id: null,
	marca_modelo: '',
	descricao: '',
	imagens: [],
};
export let ResetFuncao = {
	funcao: '',
	masculino: 0,
	feminino: 0,
};
export let OptionsSetor = [
	{ value: 'adm', label: 'Administração' },
	{ value: 'ope', label: 'Operação' },
	{ value: 'apo', label: 'Apoio' },
	{ value: 'ext', label: 'Externo e Outros' },
];



// WEBPACK FOOTER //
// ./src/components/sst/seguranca/reset.js